// src/components/NewLandingPage.js
// Landing page component
// Features: Authentication check, automatic redirect for logged-in users

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Hero from './Hero';
import BlogPreviewSection from './BlogPreviewSection';
import FeatureShowcaseSection from './FeatureShowcaseSection';
import PublicCollegePreviewSection from './PublicCollegePreviewSection';
import PracticeArenaPromoSection from './PracticeArenaPromoSection';
import DailyChallengePromoSection from './DailyChallengePromoSection';
import { applySeo } from '../utils/seo';

const NewLandingPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect authenticated users to dashboard
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    applySeo({
      title: 'Race Next Step | College Guidance, Student Blogs and Career Learning',
      description: 'Explore colleges, student blogs, and career learning resources on Race Next Step.',
      canonicalUrl: '/',
      ogType: 'website'
    });
  }, []);

  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#f9f2ff_0%,#f7efff_36%,#fbf6ff_100%)]">
      <Hero />
      <FeatureShowcaseSection />
      <PracticeArenaPromoSection />
      <DailyChallengePromoSection />
      <BlogPreviewSection />
      <PublicCollegePreviewSection />
    </div>
  );
};

export default NewLandingPage;
